import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWindowClose } from 'react-icons/fa';
import CommonModal from './CommonModal';
import { catchError, commonModalSetting } from 'JS/common';
import { cancelAdminOrder } from 'JS/API';

const AdminOrderCancelModal = ({ merchantUid, onClose, onCancelled }) => {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [innerAlertBox, setInnerAlertBox] = useState({
    mode: '',
    context: '',
    bool: false,
  });
  const [innerAlert, setInnerAlert] = useState('');
  const navigate = useNavigate();

  const handleBackgroundClick = e => {
    if (e.target === e.currentTarget) {
      e.stopPropagation();
      onClose();
    }
  };

  const handleConfirm = async () => {
    if (reason.length > 1000) {
      return commonModalSetting(
        setInnerAlertBox,
        true,
        'alert',
        '사유는 최대 1000자까지 입력 가능합니다.'
      );
    }

    setLoading(true);
    const result = await cancelAdminOrder(merchantUid, reason.trim() || null);
    setLoading(false);

    if (typeof result === 'object') {
      onCancelled();
    } else {
      catchError(result, navigate, setInnerAlertBox, setInnerAlert);
    }
  };

  return (
    <>
      <div className='modal-background' onClick={handleBackgroundClick}>
        <div className='modal admin-order-cancel'>
          <div className='topBar'>
            <h2>발행 취소</h2>
            <div onClick={onClose}>
              <FaWindowClose />
            </div>
          </div>
          <hr />
          <div className='wrap'>
            <p className='warning-text'>
              이 결제건을 취소하시겠습니까?
              <br />
              사용자는 더 이상 결제할 수 없습니다.
            </p>
            <div className='input-section'>
              <label>취소 사유 (선택)</label>
              <textarea
                rows={3}
                value={reason}
                onChange={e => setReason(e.target.value.slice(0, 1000))}
                placeholder='취소 사유를 입력해 주세요.'
              />
              <p className='hint'>{reason.length} / 1000자</p>
            </div>
            <div className='footer'>
              <div className='btn-group'>
                <button
                  className='confirm-btn'
                  onClick={handleConfirm}
                  disabled={loading}>
                  {loading ? '처리 중...' : '취소 확정'}
                </button>
                <button className='cancel-btn' onClick={onClose}>
                  닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {innerAlertBox.bool && (
        <CommonModal
          setModal={setInnerAlertBox}
          modal={innerAlertBox}
          okFn={() => {
            if (innerAlert === 'logout') navigate('/');
          }}
        />
      )}
    </>
  );
};

export default AdminOrderCancelModal;
